import React from 'react';
import { AgentPrompts } from '../config/directorPrompts';
import './QuickMenuPopover.css';

// 「快捷话术」浮层：紧凑、分组、高信息密度（PC优先）
// 点击话术只回传文本，由父组件填入输入框（不自动发送）

const QuickMenuPopover: React.FC<{
  agentPrompts: AgentPrompts;
  roleLabel: string;
  onPick: (prompt: string) => void;
  onClose: () => void;
}> = ({ agentPrompts, roleLabel, onPick, onClose }) => (
  <>
    <div className="qm-backdrop" onClick={onClose} />
    <div className="qm-popover" role="menu">
      <div className="qm-head">
        <span className="qm-head-title">快捷话术 · {roleLabel}</span>
        <span className="qm-head-note">点击填入输入框，可修改后发送</span>
      </div>
      {agentPrompts.groups.map(group => (
        <div key={group.title} className="qm-group">
          <div className="qm-group-title">{group.title}</div>
          {group.prompts.map(prompt => (
            <button
              key={prompt}
              type="button"
              className="qm-item"
              onClick={() => onPick(prompt)}
            >
              {prompt}
            </button>
          ))}
        </div>
      ))}
    </div>
  </>
);

export default QuickMenuPopover;
